module.exports = __webpack_public_path__ + "img/launchingS.48497171.png";